// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nav-links {
  list-style: none;
  margin: 20px 0px 20px 0;
  padding: 0;
  width: 100%;
  height: 100%;
  color: var(--color-muted);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}

.nav-links li {
  margin: 1rem;
  justify-content: space-between;
}

.nav-links a,
.nav-links button {
  border: none;
  margin-left: 10px;
  margin-right: 10px;
  border-radius: 6px;
  color: var(--color-white);
  text-decoration: none;
  padding: 10px 28px;
  background: var(--gradient-accent);
  cursor: pointer;
  font: inherit;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  transition: opacity 0.15s;
}

.nav-links a:hover,
.nav-links a:active,
.nav-links button:hover,
.nav-links button:active { opacity: 0.85; }

.nav-links a.active { opacity: 0.85; }

@media (min-width: 768px) {
  .nav-links {
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: center;
  }

  .nav-links li {
    margin: 0 0.05rem;
    white-space: nowrap;
  }

  .nav-links a,
  .nav-links button {
    color: var(--color-white);
    text-decoration: none;
  }

  .nav-links a.active { opacity: 0.85; }
}

/* Narrower buttons where the full menu (admins) would push the title onto
   several lines */
@media (min-width: 768px) and (max-width: 1700px) {
  .nav-links a,
  .nav-links button {
    margin-left: 4px;
    margin-right: 4px;
    padding: 10px 14px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/shared/components/Navigation/NavLinks.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,8BAA8B;AAChC;;AAEA;;EAEE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,kCAAkC;EAClC,eAAe;EACf,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;;2BAG2B,aAAa,EAAE;;AAE1C,sBAAsB,aAAa,EAAE;;AAErC;EACE;IACE,mBAAmB;IACnB,iBAAiB;IACjB,2BAA2B;IAC3B,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;;IAEE,yBAAyB;IACzB,qBAAqB;EACvB;;EAEA,sBAAsB,aAAa,EAAE;AACvC;;AAEA;kBACkB;AAClB;EACE;;IAEE,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;EACpB;AACF","sourcesContent":[".nav-links {\n  list-style: none;\n  margin: 20px 0px 20px 0;\n  padding: 0;\n  width: 100%;\n  height: 100%;\n  color: var(--color-muted);\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n}\n\n.nav-links li {\n  margin: 1rem;\n  justify-content: space-between;\n}\n\n.nav-links a,\n.nav-links button {\n  border: none;\n  margin-left: 10px;\n  margin-right: 10px;\n  border-radius: 6px;\n  color: var(--color-white);\n  text-decoration: none;\n  padding: 10px 28px;\n  background: var(--gradient-accent);\n  cursor: pointer;\n  font: inherit;\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  transition: opacity 0.15s;\n}\n\n.nav-links a:hover,\n.nav-links a:active,\n.nav-links button:hover,\n.nav-links button:active { opacity: 0.85; }\n\n.nav-links a.active { opacity: 0.85; }\n\n@media (min-width: 768px) {\n  .nav-links {\n    flex-direction: row;\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n    align-items: center;\n  }\n\n  .nav-links li {\n    margin: 0 0.05rem;\n    white-space: nowrap;\n  }\n\n  .nav-links a,\n  .nav-links button {\n    color: var(--color-white);\n    text-decoration: none;\n  }\n\n  .nav-links a.active { opacity: 0.85; }\n}\n\n/* Narrower buttons where the full menu (admins) would push the title onto\n   several lines */\n@media (min-width: 768px) and (max-width: 1700px) {\n  .nav-links a,\n  .nav-links button {\n    margin-left: 4px;\n    margin-right: 4px;\n    padding: 10px 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
